import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import { PRIMARY, SECONDARY } from '../../const/colors';
import { ButtonSpecial } from './ButtonSpecial';
import { NavLink } from 'react-router-dom';
import {ReactComponent as ArrowForwardIosIcon} from '../../assets/icons/nextArrow.svg';
import {ReactComponent as ArrowBackIosIcon} from '../../assets/icons/prevArrow.svg';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../const/api';

const ForwardIcon = styled(ArrowForwardIosIcon)`
	position: absolute;
	top: 55%;
	right: -2rem !important;
	color: ${PRIMARY} !important;
	//z-index: 1;
	transition: color 0.3s ease-in-out;
	width: 36px !important;
	height: 69px !important;

	path {
		stroke: ${PRIMARY};
		transition: all 0.3s ease-in-out;
	}
	&:hover path {
		stroke: #fff;
	}
`;
const BackIcon = styled(ArrowBackIosIcon)`
	position: absolute;
	top: 55%;
	left: -2rem !important;
	color: ${PRIMARY} !important;
	//z-index: 1;
	transition: color 0.3s ease-in-out;
	width: 36px !important;
	height: 69px !important;
	path {
		stroke: ${PRIMARY};
		transition: all 0.3s ease-in-out;
	}
	&:hover path {
		stroke: #fff;
	}
`;
const Container = styled.div`
	margin-top: 8rem;
	> h2.title {
		font-size: 2.2rem;
		color: #fff;
		margin: 1rem 0;
		font-weight: 800;
	}

	@media screen and (max-width: 480px) {
		margin-top: 3rem;
		text-align: center;
		> h2.title {
			font-size: 1.5rem;
		}
	}
`;
const Card = styled.div`
	margin-top: 3rem;
	height: 350px;
	position: relative;
`;
const CardBody = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-end;
	height: 100%;
	width: 100%;
	padding-bottom: 2rem;
	background: linear-gradient(
		180deg,
		rgba(255, 255, 255, 0) 41%,
		rgba(20, 23, 44, 0.8015581232492998) 100%
	);
	> h3 {
		color: #fff;
		font-size: 28px;
		font-weight: 800;
		margin-bottom: 2rem;
		text-align: center;
		width: 100%;
	}

	@media screen and (max-width: 1200px) {
		h3 {
			font-size: 1.5rem;
		}
	}
`;
const Link = styled(NavLink)`
	color: #ddd;
	text-decoration: underline;
	transition: color 0.3s ease;
	&:hover {
		color: #aaa;
	}
`;
const Img = styled.img`
	position: absolute;
	top: 0;
	bottom: 0;
	right: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
	object-fit: cover;
`;
const ButtonSpecial2 = styled(ButtonSpecial)`
	background-color: ${SECONDARY};
	color: ${PRIMARY};
	border: 1px solid ${PRIMARY};
	@media screen and (max-width: 1200px) {
		font-size: 0.7rem;
	}
`;
const Span = styled.span`
	position: relative;
	z-index: 2;
	&.slick-prev:before, &.slick-next:before {
		font-size: 0;
		content: '';
		height: 0;
		width: 0;
	}
`;

const SeoH1 = styled.h1`
	font-size: 0.8rem;
	color: #777;
	font-weight: 400;
	width: 90%;
	margin-bottom: 0.3rem;
	@media screen and (max-width: 768px) {
		font-size: 0.7rem;
		width: 100%;
	}
`;

const SeoH2 = styled.h2`
	font-size: 0.8rem;
	color: #777;
	font-weight: 400;
	width: 90%;
	margin-bottom: 0.3rem;
	@media screen and (max-width: 768px) {
		font-size: 0.7rem;
		width: 100%;
	}
`;

const PrevArrow = ({currentSlide, slideCount, children, ...props}) => (<Span {...props}>{children}</Span>)
const NextArrow = ({currentSlide, slideCount, children, ...props}) => (<Span {...props}>{children}</Span>)

const MultipleItems = ({ t, info }) => {
	const settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 3,
		prevArrow: (
			<PrevArrow>
				<BackIcon />
			</PrevArrow>),
		nextArrow: (
			<NextArrow>
				<ForwardIcon />
			</NextArrow>
		),
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					infinite: true,
					dots: true,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	};

	const [imagenes, setImagenes] = useState([]);

	let link = '';
	if(info==='sports') link = t('header.link-1.url');
	if(info==='casino') link = t('header.link-5.url');

	useEffect(()=>{
		const loadData = async() => {
			let ruta = info === 'sports' ? 'dep' : 'cas';
			const res = await axios.post(API_URL+"/imagenes", {ruta});
			setImagenes(JSON.parse(res.data));
		}
		loadData();
	},[])

	return (
		<Container>
			<h2 className='title'>{t(`home.carousel-${info}`)}</h2>
			{info==='sports' 
			? <SeoH1>Top Centro de Apuestas Deportivas Online en Latinoamérica: Venezuela, Chile, Ecuador, Argentina, Perú, Brasil, <br/> Panamá, México, República Dominicana - MasterBets365.</SeoH1> 
			: <SeoH2>Somos MasterBets365, el mejor Centro Deportivo Online para Apostar y Ganar en Deportes Internacionales: Fútbol, Béisbol, Baloncesto, Tenis, Boxeo, Esport. <br/> - Casino en Vivo, Poker, Ruleta, Slots, Blackjack, Tragamonedas - Parley - Juegos y Carreras de Caballos (Apuestas Hípicas).</SeoH2>}
			
			<Link to={link}>{t(`home.see-all-${info}`)}</Link>
			<Slider {...settings}>
				{imagenes.length>0 && imagenes.map((item, i) => {
					return (
						<Card key={i + 1}>
							<Img alt='' src={`https://admin.betsfactory.co/admin/contenido/${imagenes[i]}`} />
							<CardBody>
								<h3 style={{ color: i + 1 === 1 ? PRIMARY : '' }}>
									{t(`home.${info}.${i}.title`)}
								</h3>
								{i + 1 === 1 ? (
									<Link to={t(`home.${info}.${i}.url`)}>
										<ButtonSpecial>
											<span>{t(`home.btn-playNow`)}</span>
										</ButtonSpecial>
									</Link>
								) : (
									<Link to={t(`home.${info}.${i}.url`)}>
										<ButtonSpecial2>
											<span>{t(`home.btn-playNow`)}</span>
										</ButtonSpecial2>
									</Link>
								)}
							</CardBody>
						</Card>
					);
				})}
			</Slider>
		</Container>
	);
};

export default MultipleItems;
